<template>
  <div>
    <a-modal
      v-show="!ishand"
      id="supplylists"
      width="40rem"
      v-model="visible"
      on-ok="handleOk1"
      v-dragModal
      @cancel="handleCancel(0)"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
    >
      <div class="mark-file">
        <div
          style="
            background-color: #0c8b97;
            border-radius: 10px 10px 0 0;
            color: #fff;
            width: 38rem;
            margin: 1rem 1rem 0 1rem;
            text-align: center;
            font-size: 0.9rem;
          "
        >
          點擊詳情
          <!-- <span style="position: absolute; right: 9%">
            <img
              style="margin-right: 10px"
              src="../../../image/icon_tianjia.png"
              alt=""
            />
            <img src="../../../image/icon_tianjia.png" alt="" />
          </span> -->
        </div>
      </div>
      <div solt="title" style="position: relative">
        <!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
      </div>
      <div
        style="
          border-radius: 0 0 10px 10px;
          padding: 2rem 0rem 0rem;
          background-color: #fff;
          width: 38rem;
          margin: 0 auto;
          marginbottom: 1rem;
        "
      >
        <div style="width: 100%; position: relative;margin-bottom: 1rem;">
          <div
            style="
              display: flex;
              align-items: center;
              z-index: 1;
              width: 85%;
              margin: auto;
            "
          >
            <div v-if="tabClass == 2" style="display: flex;align-items: center;">
              日期
              <a-select
                ref="select"
                v-model="value1"
                style="width: 250px; margin-left: 5px"
                @change="seleClick('week')"
              >
              <a-select-option  :value="index" v-for="(item,index) in weekList" :key="index">
                <span v-if="item.and">{{item.and}} ~ </span><span>{{item.end}}</span>
              </a-select-option>
              </a-select>
            </div>
            <div v-if="tabClass == 3" style="display: flex;align-items: center;">
              日期
              <a-select
                ref="select"
                v-model="value2"
                style="width: 250px; margin-left: 5px"
                @change="seleClick('month')"
              >
                <a-select-option  :value="index" v-for="(item,index) in monthList" :key="index">{{item}}</a-select-option>
              </a-select>
            </div>
            <div v-if="tabClass == 4" style="display: flex;align-items: center;">
              日期
              <a-select
                ref="select"
                v-model="value3"
                style="width: 250px; margin-left: 5px"
                @change="seleClick('season')"
              >
                <a-select-option :value="index" v-for="(item,index) in seasonList" :key="index">{{item}}</a-select-option>
              </a-select>
            </div>
            <div v-if="tabClass == 5" style="display: flex;align-items: center;">
              日期
              <a-select
                ref="select"
                v-model="value4"
                style="width: 250px; margin-left: 5px"
                @change="seleClick('year')"
              >
                <a-select-option value="2023">2023年</a-select-option>
                <a-select-option value="2024">2024年</a-select-option>
              </a-select>
            </div>
            <div style="display: flex; margin-left: auto" class="date_tab">
              <div @click="tabClick(1)" :class="{ tab_div: tabClass == 1 }">
                日
              </div>
              <div @click="tabClick(2)" :class="{ tab_div: tabClass == 2 }">
                周
              </div>
              <div @click="tabClick(3)" :class="{ tab_div: tabClass == 3 }">
                月
              </div>
              <div @click="tabClick(4)" :class="{ tab_div: tabClass == 4 }">
                季
              </div>
              <div
                @click="tabClick(5)"
                :class="{ tab_div: tabClass == 5 }"
                style="border: none"
              >
                年
              </div>
            </div>
          </div>
          <div id="visit_data2" style="width: 100%; height: 400px"></div>
        </div>
      </div>
      <div style="width: 100%; height: 1px"></div>
    </a-modal>
  </div>
</template>

<script>
import App from "@/assets/app.js";
import * as echarts from "echarts";
import dayjs from 'dayjs';
export default {
  props: ["items"],
  data() {
    return {
      ishand: false,
      visible: true,
      value1: 0,
      value2: 0,
      value3: 0,
      value4: "2024",
      tabClass: "1",
      weekList:[], //周下拉数据
      monthList:[], //月下拉数据
      seasonList:[], //季下拉数据
      yearList:[], //年下拉数据
      dayList:[],
      monList:[],
      monthXList:[],
      seaList:[],
      seaXList:[],
      yearDataList:[],
      weekDataList:[],
      weekXList:[],

    };
  },
  watch: {},
  beforeRouteEnter(to, from, next) {
    this.getDailyLineChart()
  },
  mounted() {
    console.log(this.items);
    const currentDate = new Date().getDate();
    const currentMonth = new Date().getMonth() + 1;
    const currentYear = new Date().getFullYear();
    const currentQuarter = Math.floor(new Date().getMonth() / 3);
    /**
     * 获取当前年、当前月之前的月份 
     * 格式 例：2023-01（月份一位的话前面补零）
     * 
     */
    for (let i = 0; i < currentMonth; i++) {
      let month_data =  String(i+1).padStart(2, '0')
      this.monthList.push(currentYear + '-' + month_data)
      
    }
    /**
     * 获取当前年的当前季度范围值 
     * 格式 例：2023-01 ~ 2023-03（月份一位的话前面补零）
     * 
     */
    for (let quarter = currentQuarter - 1; quarter >= 0; quarter--) {
      const startMonth = quarter * 3;
      let startDate =  String(new Date(currentYear, startMonth, 1).getMonth() + 1).padStart(2, '0')
      let endDate =  String(new Date(currentYear, startMonth + 3, 0).getMonth() + 1).padStart(2, '0')
      this.seasonList.unshift(currentYear + '-' + startDate + ' ~ ' + currentYear + '-' + endDate);
    }
    if (currentMonth<3) {
      this.seasonList.push(currentYear + '-' + '01' + ' ~ ' + currentYear + '-' + '03')
    }
    if (currentMonth>9) {
      this.seasonList.push(currentYear + '-' + '10' + ' ~ ' + currentYear + '-' + '12')
    }
    // this.seasonList = [
    //   currentYear + '-' + '01' + ' ~ ' + currentYear + '-' + '03',
    //   currentYear + '-' + '04' + ' ~ ' + currentYear + '-' + '06',
    //   currentYear + '-' + '07' + ' ~ ' + currentYear + '-' + '09',
    //   currentYear + '-' + '10' + ' ~ ' + currentYear + '-' + '12',
    // ]
    this.calculatePreviousWeeks()
    this.$nextTick(() => {
      this.getDailyLineChart()
    });
    this.value1 = this.weekList.length-1
    this.value2 = this.monthList.length-1
    this.value3 = this.seasonList.length-1
    /**
     *     value1: 0,
      value2: 0,
      value3: 0,
     */
  },
  methods: {
    calculatePreviousWeeks() {
      const today = new Date();
      const currentDate = new Date().getDate();
      const year = today.getFullYear();
      const month = today.getMonth();
      const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
      console.log(lastDay);
      let dayVal = currentDate
      var zhouList = []
      for (let i = 0; i < dayVal; i++) {
        const firstDayOfMonth = new Date(year, month, (i+1)).getDay();
        // console.log(firstDayOfMonth);
        // 22222 第二次更改
        if (firstDayOfMonth == 1) {
          var aaa = (i+1)
          console.log(aaa);
          zhouList.push({ and:aaa})
        }
        // 22222

        // 1111
        // if (firstDayOfMonth == 0 ) {
        //   var data1 = (i+1)
        //   // year+'-'+month+'-'+ 
        //   zhouList.push({ end:data1})
        //   // console.log(data1);
        // }
        // 1111
      }
      // 1111
      // if (zhouList[zhouList.length-1].end != currentDate) {
      //   zhouList.push({ end:currentDate})
      // }
      // 1111

      zhouList.forEach(item => {
        // 22222 第二次更改
        if (item.and+4 < lastDay ) {
          item.end = item.and+4
        }else{
          item.end = lastDay

        }
        // 2222


        // 1111
        // if (item.end<7) {
        //   if (item.end>1) {
        //     item.and = 1
        //   }
        // }else{
        //   if (currentDate != item.end ) {
        //     item.and = item.end-6
        //   }else{
        //     item.and = zhouList[zhouList.length-2].end+1
        //   }
        // }
        // 1111
        
      });
      console.log(zhouList);
      zhouList.forEach(item => {
        if (item.and) {
          item.and = year + '-' +  String(month + 1).padStart(2, '0') + '-' + String(item.and).padStart(2, '0')
        }
        if (item.end) {
          item.end = year + '-' + String(month + 1).padStart(2, '0') + '-' + String(item.end).padStart(2, '0')
        }
      });
      this.weekList = zhouList
    },
    tabClick(val) {
      this.tabClass = val;
      if (val == 1) {
        this.getDailyLineChart()
      }else if (val == 2) {
        this.getWeeklyLineChart()
      }else if (val == 3) {
        this.getMonthlyLineChart()
      }else if (val == 4) {
        this.getQuarterlyLineChart()
      }else if (val == 5) {
        this.getYearlyLineChart()
      }
      // this.defineWeek();
    },
    seleClick(val){
      if (val == 'week') {
        this.getWeeklyLineChart()
      }else if (val == 'month') {
        this.getMonthlyLineChart()
      }else if (val == 'season') {
        this.getQuarterlyLineChart()
      }else if (val == 'year') {
        this.getYearlyLineChart()
        
      }
    },
    // 获取日数据
    getDailyLineChart(){
      this.$ajax({
					method: 'post',
					url: this.$api.getDailyLineChart,
					headers: {
						token: this.$store.state.token
					},
          data:{
            loginPlatform:this.items.loginPlatform,
            stockCode:this.items.stockCode
          }
				}).then(res => {
					if (res.data.qmiscode == 1000) {
            this.dayList = res.data.dailyLineChartArr
            this.defineWeek();
					} else {
						this.$message.warning(res.data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
    },
    // 获取周数据
    getWeeklyLineChart(){
      let weekVal = ''
      console.log(this.weekList);
      if(this.weekList[this.value1].and){
        weekVal  = this.weekList[this.value1].and + '~' + this.weekList[this.value1].end
      }else{
        weekVal  = this.weekList[this.value1].end
      }
      this.$ajax({
					method: 'post',
					url: this.$api.getWeeklyLineChart,
					headers: {
						token: this.$store.state.token
					},
          data:{
            dateRange:weekVal,
            loginPlatform:this.items.loginPlatform,
            stockCode:this.items.stockCode
          }
				}).then(res => {
					if (res.data.qmiscode == 1000) {
            this.weekDataList = res.data.weekDataCounts
            this.weekXList = res.data.weekDay
            this.defineWeek();
					} else {
						this.$message.warning(res.data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
    },
    // 获取月数据
    getMonthlyLineChart(){
   
      this.$ajax({
					method: 'post',
					url: this.$api.getMonthlyLineChart,
					headers: {
						token: this.$store.state.token
					},
          data:{
            monthly:this.monthList[this.value2],
            loginPlatform:this.items.loginPlatform,
            stockCode:this.items.stockCode
          }
				}).then(res => {
					if (res.data.qmiscode == 1000) {
            this.monList = res.data.monthlyLineChartArr
            this.monthXList = res.data.dateList
            const currentDate = new Date().getDate();
            const currentMonth = new Date().getMonth() + 1;
            if ((this.value2+1) == currentMonth) {
              for (let i = currentDate; i < this.monList.length; i++) {
                this.monList[i] = null
              }
            }
            this.defineWeek();
					} else {
						this.$message.warning(res.data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
    },
    // 获取季数据
    getQuarterlyLineChart(){
      this.$ajax({
					method: 'post',
					url: this.$api.getQuarterlyLineChart,
					headers: {
						token: this.$store.state.token
					},
          data:{
            quarterly:this.seasonList[this.value3].replace(/ /g, ""),
            loginPlatform:this.items.loginPlatform,
            stockCode:this.items.stockCode
          }
				}).then(res => {
					if (res.data.qmiscode == 1000) {
            this.seaList = res.data.quarterlyLineChartArr
            this.seaXList = res.data.month
            this.defineWeek();
					} else {
						this.$message.warning(res.data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
    },
    // 获取年数据
    getYearlyLineChart(){
      this.$ajax({
					method: 'post',
					url: this.$api.getYearlyLineChart,
					headers: {
						token: this.$store.state.token
					},
          data:{
            yearly:this.value4,
            loginPlatform:this.items.loginPlatform,
            stockCode:this.items.stockCode
          }
				}).then(res => {
					if (res.data.qmiscode == 1000) {
            this.yearDataList = res.data.yearDataCounts
            this.defineWeek();
					} else {
						this.$message.warning(res.data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
    },
    defineWeek() {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.init(document.getElementById("visit_data2"));
      // 日
      if (this.tabClass == 1) {
        var data = this.dayList;
        var data1 = [
          "00:00",
          "01:00",
          "02:00",
          "03:00",
          "04:00",
          "05:00",
          "06:00",
          "07:00",
          "08:00",
          "09:00",
          "10:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ];
      }
      // 周
      if (this.tabClass == 2) {
        var data = this.weekDataList;
        var data1 = this.weekXList;
      }
      // 月
      if (this.tabClass == 3) {
        var data = this.monList
        var data1 = this.monthXList
      }
      // 季
      if (this.tabClass == 4) {
        var data = this.seaList;
        var data1 = this.seaXList;
      }
      // 年
      if (this.tabClass == 5) {
        var data = this.yearDataList
        var data1 = [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月",
        ];
      }

      // 指定图表的配置项和数据
      let option = {
        xAxis: {
          type: "category",
          data: data1,
        },
        yAxis: {
          name: "點擊量",
          interval : 1,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#311878",
            },
          },
          axisLine: {
            show: false, // 隐藏 Y 轴线
          },
        },
        tooltip: {
          trigger: "axis",
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100,
          },
        ],
        series: [
          {
            type: "line",
            smooth: true,
            data: data,
            lineStyle: {
              width: 3,
            },
          },
        ],
        color: [
          {
            x: 0, // 左上角x
            y: 0, // 左上角y
            x2: 1, // 右下角x
            y2: 0, // 右下角y
            colorStops: [
              {
                offset: 1,
                color: "#f6c53c", // 0% 处的颜色
              },
              {
                offset: 0,
                color: "#fb2a29", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    // handz(val) {
    // 	this.$ajax({
    // 		method: 'post',
    // 		url: this.$api.getitem,
    // 		data: {
    // 			"flag":"systemservice",
    // 			 "contraxtid":this.items
    // 		}
    // 	}).then(res => {
    // 		if (res.data) {
    // 			this.form = res.data
    // 			// App.oTool.successT();
    // 		} else {
    // 			App.oTool.warningT(res.data.qmismsg);
    // 		}
    // 	})
    // },

    handleCancel(ev) {
      this.$emit("child", 0);
    },
    handleOk1() {},
  },
};
</script>

<style lang="scss">
#supplylists .ant-modal-header,
#supplylists .ant-modal-body {
  background-color: #e5e5e5 !important;
  padding: 1rem;
  padding-top: 0.7rem;
}

.mark-file {
  position: absolute;
  top: 0;
  left: 0;

  div {
    width: 6rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    display: inline-block;
  }
}

.mark-file1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 19rem;

  div {
    font-size: 1rem;
    padding: 0.5rem 1rem;
    background-color: #0c8b97;
    border-radius: 10px 10px 0 0;
    color: #fff;
    text-align: center;
  }
}

#supplylists {
  .ant-modal {
    top: 20vh;
  }

  .ant-form-inline .ant-form-item {
    margin-right: 0;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-form-item {
    margin-bottom: 1rem;
  }

  .ant-form-item label {
    font-size: 0.8rem !important;
  }

  .ant-form-item-children {
    font-size: 0.8rem !important;
    color: #000000;
  }

  .ant-modal-body {
    padding: 0;
    padding-top: 2.5rem;
  }
  .date_tab {
    border: 1px solid;
    border-radius: 3px;
  }
  .date_tab div {
    padding: 0px 15px;
    border-right: 1px solid;
    cursor: pointer;
  }
  .tab_div {
    background-color: #0c8b97;
    color: #ffffff;
  }
}
</style>
